
import React from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/contexts/LanguageContext';
import { Link } from 'react-router-dom';
import ConsentManager from './ConsentManager';

const CookieBanner = () => {
  return <ConsentManager />;
};

export default CookieBanner;
